<template>
  <div class="mobile-preview-wrapper">
    <div class="mobile">
      <div class="notch-wrapper">
        <div class="notch-content">
          <div class="left">{{ currentTime }}</div>
          <div class="right">
            <div class="network">
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                width="100.000000pt"
                height="100.000000pt"
                viewBox="0 0 100.000000 100.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                  fill="currentColor"
                  stroke="none"
                >
                  <path
                    d="M355 844 c-89 -17 -238 -90 -301 -148 l-49 -43 48 -57 c27 -31 51 -56 53 -56 3 0 28 18 57 39 207 155 456 159 658 12 38 -28 71 -51 73 -51 3 0 26 25 53 56 l48 57 -49 43 c-26 24 -89 65 -140 89 -143 71 -292 91 -451 59z"
                  />
                  <path
                    d="M386 604 c-68 -16 -149 -60 -188 -101 l-28 -29 54 -53 54 -53 42 31 c109 79 248 79 358 0 l44 -32 55 56 56 55 -34 30 c-104 95 -265 132 -413 96z"
                  />
                  <path
                    d="M415 360 c-47 -22 -75 -43 -75 -56 0 -5 36 -45 80 -89 l80 -80 80 80 c44 44 79 87 78 94 -2 8 -27 28 -57 43 -64 34 -128 36 -186 8z"
                  />
                </g>
              </svg>
            </div>
            <div class="battery">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.0"
                width="100.000000pt"
                height="100.000000pt"
                viewBox="0 0 100.000000 100.000000"
                preserveAspectRatio="xMidYMid meet"
              >
                <g
                  transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                  fill="currentColor"
                  stroke="none"
                >
                  <path
                    d="M111 746 c-45 -25 -50 -49 -51 -244 0 -200 6 -228 55 -250 37 -17 693 -17 730 0 34 15 55 56 55 107 0 36 3 40 28 43 l27 3 0 95 0 95 -27 3 c-25 3 -28 7 -28 42 0 52 -18 88 -51 106 -39 20 -702 20 -738 0z"
                  />
                </g>
              </svg>
              <div class="percentage">100</div>
            </div>
          </div>
        </div>
        <div class="notch"></div>
      </div>
      <div class="mobile-inner">
        <div class="mobile-app-bar">
          <i class="icon fa fa-arrow-left"></i>
          <div class="title wrap-text-1" v-text="title || 'BIBO'"></div>
        </div>
        <div class="main-content">
          <template v-if="content_type == 'url'">
            <iframe
              v-if="isValidLink()"
              :src="content"
              frameborder="0"
            ></iframe>
            <div v-else class="html-content">
              <p>Enter a valid link to preview</p>
            </div>
          </template>
          <div class="html-content" v-if="content_type == 'text-editor'">
            <div v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var currentTimeInterval = null;

export default {
  props: {
    title: {
      type: String,
      default: "BIBO",
    },
    content_type: {
      type: String,
      default: "text-editor",
    },
    content: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentTime: 0,
    };
  },
  mounted() {
    this.setTime();

    currentTimeInterval = setInterval(() => {
      this.setTime();
    }, 1000);
  },
  beforeDestroy() {
    if (currentTimeInterval) {
      clearInterval(currentTimeInterval);
      currentTimeInterval = null;
    }
  },
  destroyed() {
    if (currentTimeInterval) {
      clearInterval(currentTimeInterval);
      currentTimeInterval = null;
    }
  },
  methods: {
    setTime() {
      // set hh:mm format
      let currentTime = new Date().toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      // remove am/pm
      currentTime = currentTime.replace(/(AM|PM)/, "");

      // remove space
      currentTime = currentTime.replace(/ /, "");

      this.currentTime = currentTime;
    },
    isValidLink() {
      if (this.content && this.content !== "") {
        try {
          const url = new URL(this.content);

          if (url.protocol === "http:" || url.protocol === "https:") {
            return true;
          }
        } catch {
          return false;
        }
      }

      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-preview-wrapper {
  overflow: auto;
  position: sticky;
  top: 10px;
}
.mobile {
  position: relative;
  width: 390px;
  height: 800px;
  // max-height: 98vh;
  background: #111;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border: 15px solid #111;
  border-radius: 44px;
  display: flex;
  flex-direction: column;
  .notch-wrapper {
    position: relative;
    width: 100%;
    height: 42px;
    .notch-content {
      position: relative;
      top: 0.6px;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 25px;
      background: #4633bd;
      color: #fff;
      .left {
        font-size: 14px;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;

        .network {
          margin-right: 5px;
          svg {
            height: 19px;
            width: 19px;
            position: relative;
            top: -2px;
          }
        }
        .battery {
          position: relative;
          svg {
            height: 26px;
            width: 26px;
          }
          .percentage {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 10px;
            font-weight: 900;
            color: #4633bd;
          }
        }
      }
    }
    .notch {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 46%;
      height: 30px;
      background: #111;
      border-radius: 0 0 20px 20px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    }
  }
  .mobile-inner {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    .mobile-app-bar {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.29);
      .icon {
        font-size: 16px;
        color: #3c3c3c;
        margin-right: 20px;
      }
      .title {
        font-size: 17px;
        color: #161616;
        font-weight: 500;
        letter-spacing: 0.2px;
        word-break: break-all;
      }
    }
    .main-content {
      position: relative;
      width: 100%;
      height: 100%;
      flex: 1;
      iframe {
        width: 100%;
        height: 100%;
      }
      .html-content {
        padding: 1.2rem;
        color: #161616;
        font-size: 14px;
        overflow: auto;
      }
    }
  }
}
</style>